import styled from 'styled-components';

export const CircleProgressContainer = styled.span`
  font-size: 1.4rem;
`;
